import { render, staticRenderFns } from "./CardMessage.vue?vue&type=template&id=0612e052&scoped=true&"
import script from "./CardMessage.vue?vue&type=script&lang=js&"
export * from "./CardMessage.vue?vue&type=script&lang=js&"
import style0 from "./CardMessage.vue?vue&type=style&index=0&id=0612e052&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0612e052",
  null
  
)

export default component.exports